module.exports = __webpack_public_path__ + "img/title.0a5d629b.png";